/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for VisionObjectDetection controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { VisionObjectDetectionRequest, RequestOptions, VisionObjectDetectionResponse } from "../models";

@Injectable({ providedIn: "root" })
export class VisionObjectDetectionService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    detectObjectsAi(visionObjectDetectionRequest: VisionObjectDetectionRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<VisionObjectDetectionResponse>;
    detectObjectsAi(visionObjectDetectionRequest: VisionObjectDetectionRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<VisionObjectDetectionResponse>>;
    detectObjectsAi(visionObjectDetectionRequest: VisionObjectDetectionRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<VisionObjectDetectionResponse>>;
    detectObjectsAi(visionObjectDetectionRequest: VisionObjectDetectionRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/detect-objects/ai`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: visionObjectDetectionRequest,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
